export default __webpack_public_path__ + "static/media/Verantos_icon.6ea16923.svg";